import SchematicIcon from 'src/assets/icons/schematic.svg';
import { Icon } from '@oliasoft-open-source/react-ui-library';
import { CasingRenderer } from './casing-renderer';

export const casingRenderTab = {
  icon: <Icon icon={SchematicIcon} />,
  content: <CasingRenderer />,
};
